var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Info",
    "data-name": "Icon - Info",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 13,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_256",
    "data-name": "Path 256",
    fill: "#981e28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 15 C 4.140190124511719 15 1 11.85980987548828 1 8 C 1 4.140190124511719 4.140190124511719 1 8 1 C 11.85980987548828 1 15 4.140190124511719 15 8 C 15 11.85980987548828 11.85980987548828 15 8 15 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 2 C 4.691590309143066 2 2 4.691590309143066 2 8 C 2 11.30841064453125 4.691590309143066 14 8 14 C 11.30841064453125 14 14 11.30841064453125 14 8 C 14 4.691590309143066 11.30841064453125 2 8 2 M 8 0 C 12.41827964782715 0 16 3.581720352172852 16 8 C 16 12.41827964782715 12.41827964782715 16 8 16 C 3.581720352172852 16 0 12.41827964782715 0 8 C 0 3.581720352172852 3.581720352172852 0 8 0 Z",
    stroke: "none",
    fill: "#981e28"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_1",
    "data-name": "Repeat Grid 1",
    transform: "translate(10 14) rotate(180)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 -2)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "i",
    transform: "translate(8 12)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "FiraSans-SemiBold, Fira Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.551,
    y: 0
  }, "i"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlertIcon);
export default __webpack_public_path__ + "static/media/RedAlertIcon.caac2ef4ab48a966d8fb674f082b987c.svg";
export { ForwardRef as ReactComponent };